import ArrowDownIcon from '../../atoms/icons/arrowDown';
import Container from '../../atoms/container/parentalPinDialDownContainer';
import { ParentalPinDialIconProps as Props } from '../../../../shared/types/props/parentalPin';

function ParentalPinDialDown({ callback }: Props) {
  return (
    <Container onClick={() => callback && callback()}>
      <ArrowDownIcon />
    </Container>
  );
}

export default ParentalPinDialDown;
